<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted, reactive, ref, nextTick } from 'vue'
import { Head, useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import TextInput from '@/Shared/Form/TextInput'
import Pagination from '@/Shared/Pagination'
import Icon from '@/Shared/Icons/Icon'
import stripslashes from '@/Shared/helper.js'
import FinderStoreInfo from './FinderStoreInfo'
import usePref from '@/Shared/usePref.js'
import useFavorites from '@/Shared/useFavorites.js'
import useIntersectionObserver from '@/Shared/useIntersectionObserver.js'

const props = defineProps({
  stores: Object,
  prefectures: Object,
  area: String,
  brand: String,
  keyword: String,
  pref: Object,
})

const resultRef = ref()
const targetRef = ref()

const state = reactive({
  keyword: String,
  brand: String,
  area: String,
})

const favorite = reactive({
  all: [],
})

const checkState = () => {
  if (props.keyword) {
    state.keyword = props.keyword
  }
  if (props.brand) {
    state.brand = stripslashes(props.pref.brands.filter((item) => item.brandSlug === props.brand)[0].brandName)
  }
  if (props.area) {
    state.area = stripslashes(props.prefectures.filter((item) => item.stateISO === props.area)[0].stateNameLocal)
  }
}
checkState()

const submitform = () => {
  let d = {}
  if (form.keyword != '') d.keyword = form.keyword
  if (form.brand != '') d.brand = form.brand
  if (form.area != '') d.area = form.area
  Inertia.visit('/stores/finder', {
    method: 'get',
    data: d,
    // preserveScroll: true,
  })
}

const toggleMenu = () => {
  searchOption.menustats = !searchOption.menustats
  document.querySelector('html').scrollTo(0, 0)
}

const searchOption = reactive({
  keyword: props.keyword != '' ? props.keyword : '',
  menustats: true,
  focus: -1,
})

const form = useForm('form', {
  keyword: props.keyword,
  brand: props.brand,
  area: props.area,
})

const getheaderH = () => document.querySelector('.header').clientHeight

const buildThresholdList = (steps) => {
  let thresholds = [0]
  for (let i = 1.0; i <= steps; i++) {
    thresholds.push(i / steps)
  }
  return thresholds
}

const setTargetHeight = () => {
  // if (searchOption.menustats) return
  // const targetY = targetRef.value.getBoundingClientRect().top
  // const targetH = document.querySelector('.main-body').offsetHeight - targetY
  // targetRef.value.style.height = targetH + 'px'
}

const observeResult = () => {
  useIntersectionObserver({
    target: targetRef.value,
    threshold: buildThresholdList(100),
    rootMargin: '300px',
    onEnter: (entry) => {
      if (entry.boundingClientRect.y < getheaderH()) {
        resultRef.value.classList.add('fixed')
        resultRef.value.classList.remove('absolute')
        resultRef.value.style.top = getheaderH() + 'px'
      } else {
        resultRef.value.classList.add('absolute')
        resultRef.value.classList.remove('fixed')
        resultRef.value.style.top = 'auto'
      }
    },
  })
}

onMounted(() => {
  usePref(props.pref)

  if (props.area != '' || props.brand != '' || props.keyword != '') {
    searchOption.menustats = false
  }
  const { sortFavoriteList, subscribeFavoriteList } = useFavorites({ favorite: favorite, category: 'brand' })
  sortFavoriteList()
  subscribeFavoriteList(sortFavoriteList)

  nextTick(() => {
    // setTargetHeight()
    // observeResult()
  })
})
</script>

<template>
  <div class="search">
    <Head title="取り扱い店舗検索" />

    <div class="bg-white md:min-h-[calc(100vh_-_75px)] xl:min-h-screen md:grid md:items-center">
      <div>
        <h2 class="page-title">
          SEARCH
          <small>取り扱い店舗検索</small>
        </h2>

        <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] lg:px-0 max-w-[600px] pb-[60px] sm:pb-[80px]">
          <template v-if="searchOption.menustats">
            <form class="bg-white mb-[40px]" @submit.prevent="submitform">
              <ul class="[&>li]:mb-[20px] [&_input]:placeholder:!text-[#444] [&_select]:!text-[#444]">
                <li>
                  <text-input v-model="form.keyword" type="text" autofocus autocapitalize="off" placeholder="キーワードで検索" :is-search="true" />
                </li>
                <li>
                  <select id="brand-filter" v-model="form.brand" name="brand-filter" class="form-select">
                    <option value="">ブランドを選択</option>
                    <option v-for="o in favorite.all" :key="o.brandSlug" :value="o.brandSlug">{{ stripslashes(o.brandName) }}</option>
                  </select>
                </li>
                <li>
                  <select id="area-filter" v-model="form.area" name="area-filter" class="form-select">
                    <option value="">エリアを選択</option>
                    <option v-for="a in prefectures" :key="a.stateSlug" :value="a.stateISO">{{ a.stateNameLocal }}</option>
                  </select>
                </li>
              </ul>
              <button type="submit">検索する<Icon type="arrow" /></button>
            </form>
          </template>

          <template v-if="!searchOption.menustats">
            <div class="mt-[-20px]" />
            <div ref="resultRef" class="relative z-20 bg-white  py-[20px] text-[110%] font-semibold leading-[1.6] border-b border-b-black border-dotted">
              <div class="relative flex mb-[5px]">
                <div class="whitespace-nowrap">検索条件：</div>
                <div class="relative flex flex-wrap grow">
                  <div v-if="props.keyword" class="sm:mr-[10px]"><span class="hidden sm:inline">キーワード</span>「{{ state.keyword }}」</div>
                  <div v-if="props.brand" class="sm:mr-[10px]"><span class="hidden sm:inline">ブランド</span>「{{ state.brand }}」</div>
                  <div v-if="props.area"><span class="hidden sm:inline">エリア</span>「{{ state.area }}」</div>
                </div>
              </div>
              <div>検索結果：{{ stores.total }}件</div>
              <button class="absolute p-[20px] right-[-20px] bottom-0 sm:bottom-[10px]" @click="toggleMenu()">再検索<Icon type="search" class="inline-block ml-[5px]" /></button>
            </div>

            <div ref="targetRef" class="absolute w-full left-0 -z-10" />


            <div class="pt-[20px]">
              <template v-if="stores.data.length === 0">
                <div class="border-t border-t-black border-dotted text-center">
                  <p class="my-[100px] sm:my-[150px] text-[110%]">条件に該当するストアはありません。</p>
                </div>
              </template>
              <template v-else>
                <template v-if="brand == 'rocky_mountain_bicycles'">
                  <div class="categoryBlock">
                    <h4>Rocky Mountain Bicycles ディーラー</h4>
                    <ul class="rocky-dealers">
                      <li>
                        <span class="txt txt1">
                          ロッキーマウンテンを豊富に取り扱うディーラーです。アフターサービスまでトータルでサポートいたします。
                        </span>
                      </li>
                      <li>
                        <span class="txt txt2">ロッキーマウンテンの取扱いに長けたディーラーです。高水準のサービスを提供いたします。</span>
                      </li>
                      <li>
                        <span class="txt txt3">ロッキーマウンテン正規ディーラー</span>
                      </li>
                    </ul>
                  </div>
                </template>
                <template v-else-if="brand == 'mysteryranch'">
                  <div class="categoryBlock">
                    <h4>Mystery Ranch 取扱カテゴリー</h4>
                    <ul class="mysteryranch-dealers">
                      <li>
                        <img src="/img/finder/mountain-logo.jpg" alt="Mountain">
                        <span>Mountain</span>
                      </li>
                      <li>
                        <img src="/img/finder/everyday-logo.jpg" alt="Everyday">
                        <span>Everyday</span>
                      </li>
                      <li>
                        <img src="/img/finder/hunting-logo.jpg" alt="Hunting">
                        <span>Hunting</span>
                      </li>
                      <li>
                        <img src="/img/finder/fire-logo.jpg" alt="Fire">
                        <span>Fire</span>
                      </li>
                      <li>
                        <img src="/img/finder/military-logo.jpg" alt="Military">
                        <span>Military</span>
                      </li>
                    </ul>
                  </div> 
                </template>
                <template v-else-if="brand == 'kona'">
                  <div class="categoryBlock">
                    <h4>KONA ディーラー</h4>
                    <ul class="kona-dealers">
                      <li>
                        <span class="txt txt1">
                          KONA BICYCLESを豊富に取り扱うディーラーです。アフターサービスまでトータルでサポートいたします。
                        </span>
                      </li>
                      <li>
                        <span class="txt txt2">KONA BICYCLESの取扱いに長けたディーラーです。高水準のサービスを提供いたします。</span>
                      </li>
                      <li>
                        <span class="txt txt3">KONA BICYCLES正規ディーラー</span>
                      </li>
                    </ul>
                  </div>
                </template>
                <ul class="relative z-10">
                  <li v-for="shop in stores.data" :key="shop" class="leading-[1.6] border-b border-b-black border-dotted [&>div]:py-[20px] [&>a]:block ">
                    <template v-if="shop.shopType == 1 && shop.shopUrl != ''">
                      <FinderStoreInfo :data="shop" />
                    </template>
                    <template v-else-if="shop.shopType == 0">
                      <FinderStoreInfo :data="shop" />
                    </template>
                    <template v-else>
                      <FinderStoreInfo :data="shop" />
                    </template>
                  </li>
                </ul>
                <pagination class="mt-6" :links="stores.links" />
              </template>
            </div>
          </template>

          <div class="text-[#777] [&>p]:mb-[20px] leading-[1.6] mt-[40px] sm:mt-[50px]">
            <p>※店舗検索のリストは卸し先様への出荷履歴などを元に作成しておりますので、リストの店舗様の商品在庫を確約するものではございません。</p>
            <p>※又、店舗在庫は常に流動的でございます。ご来店の前には必ずお電話等で在庫の確認をしていただくよう、お願い申し上げます。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
